import React, { useMemo } from "react";
import routesConfig from "@/config/routes.config";
import RxSubNav from "./RxSubNav";

const RxSubNavAcademy: React.FC = (props): JSX.Element => {
  const subroutes = useMemo(
    () => routesConfig.find(({ name }) => name === "academy")?.routes || [],
    []
  );

  return <RxSubNav items={subroutes} {...props} />;
};

export default RxSubNavAcademy;
